import Http from 'axios'
import {
    API_URL,
    VERSION
} from '../../../config/config'

import {buildFormData} from "../../../helpers/FormdData";

function initialState() {
    return {
        trekkingAgencyData: {},
        trekkingData: {
            trekkers: [{
                visa_number: "",
                passport_number: "",
                country: '',
                name: ''
            }, {
                visa_number: "",
                passport_number: "",
                error: ""
            }],
            nepaliGuide: {},
            porter: [],
            exemption: {},
            isExtension: false,
            isExpedition: false
        },
        newRequestMade: false,
        loading: false,
        trekkingRequestDetails: [],
    }
}

const getters = {
    loading: state => state.loading,
    trekkingData: state => state.trekkingData,
    trekkingRequestDetails: state => state.trekkingRequestDetails,
    trekkingAgencyData: state => state.trekkingAgencyData,
    newRequestMade: state => state.newRequestMade
}

const actions = {
    getTrekkingRequestDetail({
                                 commit,
                                 state
                             }, id) {
        commit('setLoading', true)
        return new Promise((resolve, reject) => {
            Http.get(API_URL + VERSION + '/trekkings/get/' + id)
                .then(response => {
                    commit('setLoading', false)
                    commit('setTrekkinData', response.data.data);
                    resolve(response)
                })
                .catch(error => {
                    commit('setLoading', false)
                    reject(error)
                })
        });
    },
    createTrekkingRequest({
                              commit,
                              state
                          }) {
        commit('setLoading', true)
        let formData = new FormData();
        buildFormData(formData, state.trekkingData)
        return new Promise((resolve, reject) => {
            Http.post(API_URL + VERSION + '/trekkings/permit/save', formData)
                .then(response => {
                    commit('setTrekkingRequestDetails', response.data);
                    commit('setLoading', false);
                    resolve(response)
                })
                .catch(error => {
                    commit('setLoading', false)
                    reject(error)
                })
        });
    },
    updateTrekkingRequest({
                              commit,
                              state
                          }) {
        commit('setLoading', true)
        let formData = new FormData();
        buildFormData(formData, state.trekkingData)
        return new Promise((resolve, reject) => {
            Http.post(API_URL + VERSION + '/trekkings/permit/' + state.trekkingData.id, formData)
                .then(response => {
                    commit('setTrekkingRequestDetails', response.data);
                    commit('setLoading', false);
                    resolve(response)
                })
                .catch(error => {
                    commit('setLoading', false)
                    reject(error)
                })
        });
    },
    async checkVisaValidity({commit, state}, data) {
        try {
            const response = await Http.get(`${API_URL}${VERSION}/visa-passport-validity?passport_number=${data.passport_number}&visa_number=${data.visa_number}`);
            commit('setSingleTravellerData', {
                passport_number: data.passport_number,
                visa_number: data.visa_number,
                ...response.data.data
            });

        } catch (e) {
            throw e;
        }
    },
    async checkProceedVisaValidity({commit, state}, data) {
        let errors = [];
        const trekkers = JSON.parse(JSON.stringify(state.trekkingData.trekkers));
        const responses = await Promise.all(
            trekkers.map(async trekker => {
                try {
                    if (trekker.indian_without_visa) {
                        commit('setSingleIndianData', trekker);
                        return true;
                    }
                    const response = await Http.get(`${API_URL}${VERSION}/visa-passport-validity?
                    passport_number=${trekker.passport_number}&visa_number=${trekker.visa_number}&last_date=${data.last_date}`);
                    commit('setSingleTravellerData', {
                        passport_number: trekker.passport_number,
                        visa_number: trekker.visa_number,
                        dob: trekker.dob,
                        ...response.data.data
                    });
                    return {found: true};
                } catch (e) {
                    return {found: false, errors: e.response.data.message};
                }
            })
        );
        for (let i = 0; i < responses.length; i++) {
            if (responses[i].found === false) {
                errors.push(responses[i].errors);
            }
        }

        return errors;
    },
    updatePaymentStatus({
                            commit,
                            state
                        }, data) {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            Http.post(API_URL + VERSION + '/trekkings/update-payment-status', data)
                .then(response => {
                    commit('setLoading', false);
                    commit('setTrekkinData', response.data.data);
                    resolve(response)
                })
                .catch(error => {
                    commit('setLoading', false);
                    reject(error)
                })
        });
    },
    resetState({
                   commit
               }) {
        commit('resetState')
    },
    resetTrekkingData({commit}) {
        commit('resetTrekkingData')
    },
    checkPaymentStatus({state}, payload) {
        return new Promise((resolve, reject) => {
            Http.put(API_URL + VERSION + '/trekkings/check-payment-status/' + payload.submission_number).then((res) => {
                resolve(res.data);
            }).catch((err) => {
                reject(err)
            });
        })
    },
    proceedOnlinePayment({state}, payload) {
        return new Promise((resolve, reject) => {
            Http.get(API_URL + VERSION + '/proceed-online-payment/' + payload.submission_number).then((res) => {
                resolve(res.data);
            }).catch((err) => {
                reject(err)
            });
        })
    },
    async downloadPermit({state, commit}) {
        commit('setLoading', true);
        try {
            const {data} = await Http.get(API_URL + VERSION+ '/trekkings/download-permit/' + state.trekkingData.id)
            this.commit("Notification/showSuccess", 'Trekking Permit Downloaded Successfully')
            window.open(data.link, '_blank')
        } catch (e) {
            this.commit('Notification/showError', e.response.data.message)
        } finally {
            commit('setLoading', false)
        }
    }
}

const mutations = {
    setTrekkingAgencyData(state, items) {
        state.trekkingAgencyData = items
    },
    setSingleTravellerData(state, item) {
        state.trekkingData.trekkers = state.trekkingData.trekkers.map((trekker) => {
            if (trekker.passport_number === item.passport_number && trekker.visa_number === item.visa_number) {
                trekker.name = item.name;
                trekker.country = item.country;
                trekker.dob = item.dob;
            }
            return trekker;
        });
    },
    setSingleIndianData(state, item) {
        state.trekkingData.trekkers = state.trekkingData.trekkers.map((trekker) => {
            if (trekker.passport_number === item.passport_number && trekker.contact_no === item.contact_no) {
                trekker.name = item.full_name;
                trekker.country = 'India'
            }
            return trekker;
        });
    },
    setTrekkinData(state, items) {
        state.trekkingData = items
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setTrekkingRequestDetails(state, trekkingRequestDetails) {
        state.trekkingRequestDetails = trekkingRequestDetails
    },
    resetState(state) {
        state = Object.assign(state, initialState());
        state.trekkingData.starting_date = '';
    },
    resetTrekkingData(state) {
        state.trekkingData = {
            trekkers: [{
                visa_number: "",
                passport_number: "",
                country: '',
                name: ''
            }, {
                visa_number: "",
                passport_number: "",
                error: ""
            }],
            nepaliGuide: {},
            porter: [],
            exemption: {},
            isExtension: false,
            isExpedition: false
        }
    },

    setTrekkerInfo(state, trekkers) {
        state.trekkingData.trekkers = trekkers;
    },
    setNewRequestMade(state, newRequestMade) {
        state.newRequestMade = newRequestMade;
    }
}

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}
